import { render, staticRenderFns } from "./batchEditPixel.vue?vue&type=template&id=023623a4"
import script from "./batchEditPixel.vue?vue&type=script&lang=js"
export * from "./batchEditPixel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports